import React from 'react';

import moment from 'moment';
import 'moment/locale/es';
import { Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';

const FormItem = Form.Item;
moment.locale();

class FormEfectosActuales extends React.Component {
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let valor = this.evaluarPuntaje(values);

        let respuestas = {
          ...values,
          valor,
        };

        // console.log(this.props);
        this.props.onSubmit(respuestas);
      }
    });
  };

  evaluarPuntaje = respuestas => {
    let valor = 0;
    //Lo que busco a continuacion es sumar los valores, pero como estan en STRINGS, primero debo aplicar el operador UNARIO + para convertirlos a INT.

    if (respuestas.dificultadesEstudio) {
      valor = valor + 3;
    }

    if (respuestas.maltratoExtendido) {
      valor = valor + 2;
    }

    if (respuestas.problemasLaborales) {
      valor = valor + 3;
    }

    if (respuestas.limitacionBusquedaEmpleo) {
      valor = valor + 3;
    }

    if (respuestas.perdioEmpleo) {
      valor = valor + 4;
    }

    return valor;
  };

  render() {
    moment.locale();
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <div>
        <h1 className="tituloForm">
          Evaluación Efectos Actuales de la Violencia
        </h1>

        <Form onSubmit={this.handleSubmit} className="formulariosViolencia">
          {' '}
          <FormItem
            {...formItemLayout}
            label="Dificultades/Perdida del estudio"
          >
            {getFieldDecorator('dificultadesEstudio', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Maltrato extendido a la familia">
            {getFieldDecorator('maltratoExtendido', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Problemas laborales por la violencia"
          >
            {getFieldDecorator('problemasLaborales', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Limitacion en la busqueda de empleo"
          >
            {getFieldDecorator('limitacionBusquedaEmpleo', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Perdió empleo por violencia">
            {getFieldDecorator('perdioEmpleo', {
              initialValue: false,
            })(<Checkbox />)}
          </FormItem>
          <FormItem {...tailFormItemLayout}>
            <Button style={{ margin: 10 }} type="primary" htmlType="submit">
              Siguiente
            </Button>
            <Button
              style={{ margin: 10 }}
              type="danger"
              onClick={this.props.onCancel}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create()(FormEfectosActuales);
